import {productService} from '@/assets/js/http'

/**
 * 问卷详情
 */
 export function questionnaireDetailAPI(id) {
    return productService({
        url:`api/haiyan/questionnaire/questionnairepage/${id}`,
        method: 'get'
    })
}

// 提交问卷
export function questionnaireSubmitAPI(data) {
    return productService({
        url:`api/haiyan/questionnaire/savequestionnaireresults`,
        method: 'post',
        data
    })
}

/**
 * 问卷记录详情
 */
 export function questionnaireRecordDetailAPI(id) {
    return productService({
        url:`api/haiyan/questionnaire/questionnairerecorddetail/${id}`,
        method: 'get'
    })
}